import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { GetLatestBillsDto } from "../model/bill/dto/GetLatestBillsDto";
import { Button } from "./Button";
import { AtiraToast } from "../utils/AtiraToast";
import { useAppDispatch, useAppSelector } from "../redux/store";
import omitBy from "lodash/omitBy";
import isNil from "lodash/isNil";
import isEmpty from "lodash/isEmpty";
import { billActions } from "../redux/bill/bill.slice";
import { PageMeta } from "../model/meta/PageMeta";
import { billSliceSelectors } from "../redux/bill/bill.selector";

type FiltersModalProps = {
  open: boolean;
  onClose: VoidFunction;
};

export const FiltersModal: React.FC<FiltersModalProps> = ({
  open = false,
  onClose,
}) => {
  const [loading, setLoading] = useState(false);

  const { control, register, setValue, getValues } =
    useFormContext<GetLatestBillsDto>();

  const dispatch = useAppDispatch();

  const billsPageSize = useAppSelector(
    billSliceSelectors.selectBillsTablePageSize
  );
  const billsPage = useAppSelector(billSliceSelectors.selectBillsTablePage);

  const onFilter = async () => {
    try {
      setLoading(true);

      const filter = omitBy(getValues(), isNil);
      const isFilterEmpty = Object.values(filter).every((v) => isEmpty(v));

      if (!isFilterEmpty) {
        dispatch(billActions.setBillsTablePage(1));
        dispatch(billActions.setBillsTablePageSize(10));
      }

      dispatch(
        billActions.getLatestBills({
          meta: !isFilterEmpty
            ? PageMeta.create({ count: 10, page: 0 })
            : {
                count: billsPageSize,
                page: billsPage - 1,
              },
          ...filter,
        })
      ).unwrap();

      onClose();
    } catch (e) {
      console.error(e);
      AtiraToast.apiError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={open} onHide={onClose}>
      <Modal.Header closeButton className="justify-content-between">
        <Modal.Title>Filter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column gap-2">
          <Controller
            control={control}
            name="minTotalAmount"
            render={({ field: { value, onChange } }) => (
              <input
                type="text"
                className="form-control"
                placeholder="Min Total Amount"
                value={value}
                onChange={(e) => {
                  const numericValue = e.currentTarget.value.replace(
                    /[^0-9.]/g,
                    ""
                  );
                  onChange(numericValue);
                }}
              />
            )}
          />

          <Controller
            control={control}
            name="maxTotalAmount"
            render={({ field: { value, onChange } }) => (
              <input
                type="text"
                className="form-control"
                placeholder="Max Total amount"
                value={value}
                onChange={(e) => {
                  const numericValue = e.currentTarget.value.replace(
                    /[^0-9.]/g,
                    ""
                  );
                  onChange(numericValue);
                }}
              />
            )}
          />

          <input
            className="form-control"
            placeholder="Date"
            type="date"
            {...register("creationDate", {
              onChange: (e) => {
                setValue("creationDate", e.target.value);
              },
            })}
          />

          <Button
            onClick={onFilter}
            loading={loading}
            className="btn btn-primary mt-3"
          >
            Apply
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
